export function footerFunc() {
  const footer = document.querySelector('.site-footer-content');
  const body = document.querySelector('body');
  const homeUrl = document.querySelector('body').dataset.homeUrl;

  // コピーライト書き換え
  // const copyRight = document.querySelector('.site-footer-copyright');
  // copyRight.innerHTML = 'Copyright(C) 播磨屋塗匠株式会社. CO., LTD. All Rights Reserved';

  /**
   * 追従CTAボタンの設置
   */
  const ctaFixed = document.createElement('div');
  ctaFixed.classList.add('p-fixed-cta');
  ctaFixed.innerHTML = `
    <a href="${homeUrl}contact" class="p-fixed-cta__link is-contact">
      <span class="is-icon"></span>
      <span class="is-text">お問い合わせ</span>
    </a><!-- /.p-fixed-cta__link -->
    <a href="https://line.me/R/ti/p/@028qaesg" class="p-fixed-cta__link is-line" target="_blank">
      <span class="is-icon"></span>
      <span class="is-text"><span class="is-line-text">LINE</span><span class="is-sodan-text">で<br>相<br>談</span></span>
    </a><!-- /.p-fixed-cta__link -->
  `;

  const pageTop = document.createElement('a');
  pageTop.setAttribute('href', '#');
  pageTop.classList.add('p-page-top');
  pageTop.innerHTML = `
    <div class="is-dot"></div>
    <span class="is-text">TOP</span>
  `;

  body.appendChild(ctaFixed);
  body.appendChild(pageTop);

  /**
   * スクロールで追従CTAボタンの表示・非表示
   */
  let scrollY = 0;
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 80) {
      ctaFixed.classList.add('is-show');
      pageTop.classList.add('is-show');
    } else {
      ctaFixed.classList.remove('is-show');
      pageTop.classList.remove('is-show');
    }
  });
};
